import { atom } from "recoil";
import type { PackagingSectionRequest } from "@/pages-components/packaging/packaging-document-kind";

/**
 * One-shot flag set when hasPACKItem should show the packaging notice.
 * The modal consumes it (sets false) as soon as it opens, so leaving and
 * re-entering the document page does not reopen the modal.
 */
export const packagingOutdatedNoticePendingState = atom<boolean>({
  key: "packagingOutdatedNoticePendingState",
  default: false,
});

/**
 * One-shot flag to open the packaging builder from the outdated notice.
 * Consumed (set false) as soon as Pack & Ship opens, so remounting the
 * cart page does not reopen the packaging modal.
 */
export const packagingModalOpenPendingState = atom<boolean>({
  key: "packagingModalOpenPendingState",
  default: false,
});

/**
 * Section requested together with packagingModalOpenPendingState when Pack & Ship
 * is opened from a cart line ("Edit"). Consumed with the pending flag by the
 * buttons container, so other entry points always open the default section.
 */
export const packagingModalSectionRequestState =
  atom<PackagingSectionRequest | null>({
    key: "packagingModalSectionRequestState",
    default: null,
  });

/**
 * Set together with packagingModalOpenPendingState to open Pack & Ship read-only
 * (invoice / delivery note "Show ..." cart actions). Consumed with the pending flag.
 */
export const packagingModalViewOnlyRequestState = atom<boolean>({
  key: "packagingModalViewOnlyRequestState",
  default: false,
});
